import * as ActionType from '../constants/constant_action_types';

export default (state = null, action) => {
  if(action.type===ActionType.APPLY_INTL) {
    return action.intl;
  }
  return state;
};